export const CONTENT_FEATURE_KEY = 'content';
